import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateScholarshipCampaigns = () => {
  return (
    <Create
      title="Създаване на кампания за стипендии"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateScholarshipCampaigns;
